module.exports = __webpack_public_path__ + "static/taka-8c81f363a125f6967f97a28618d7b327.jpg";